import { Helmet } from 'react-helmet';
import type { VoidFunctionComponent } from 'react';

import { useRouter } from '../../../contexts/RouterContext';
import { useOnMount } from '../../../hooks';
import { useSynchronizeSubscription } from '../../../hooks/api/subscriptions/useSynchronizeSubscription';
import Card from '../../generic/Card/Card';
import Loader from '../../generic/Loader';

/**
 * This page is just a landing page for Stripe checkout sessions.
 * It ensures the org subscription is synchronized with Stripe before redirecting to the
 * new plans page.
 */
const PlanUpdateCallback: VoidFunctionComponent = () => {
  const {
    mutateAsync: synchronizeSubscription,
  } = useSynchronizeSubscription();

  const router = useRouter();

  useOnMount(async () => {
    await synchronizeSubscription();
    router.replace('/account/settings/billing?tab=Plans&update_success=true');
  });

  return (
    <div className="container margin-top">
      <Helmet title="Subscription" />
      <Card isFullWidth>
        <Card.Header>
          <h1>Subscription</h1>
        </Card.Header>
        <Card.Content>
          <h1>Loading...</h1>
          <Loader />
        </Card.Content>
      </Card>
    </div>
  );
};

export default PlanUpdateCallback;
